import React from 'react';

const TrustSection = ({ isCollapsed, onNavigate }) => {
  return (
    <footer className={`fixed bottom-0 right-0 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 z-40 transition-all duration-300 h-12 flex items-center ${
      isCollapsed ? 'left-20' : 'left-64'
    }`}>
      <div className="w-full px-6 py-3 flex items-center justify-between text-xs">
        <div className="flex items-center space-x-4">
          <span className="text-gray-600 dark:text-gray-300 transition-colors duration-300">
            © 2025 Tabulara by{' '}
            <a 
              href="https://dssolution.id/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 hover:underline transition-colors duration-200"
            >
              DS Solution
            </a>
            . All rights reserved.
          </span>
          <span className="text-gray-400 dark:text-gray-600 transition-colors duration-300">|</span>
          <button
            onClick={() => onNavigate && onNavigate('privacy-security')}
            className="text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-white transition-colors duration-200"
          >
            Privacy & Security
          </button>
          <span className="text-gray-400 dark:text-gray-600 transition-colors duration-300">|</span>
          <button
            onClick={() => onNavigate && onNavigate('documentation')}
            className="text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-white transition-colors duration-200"
          >
            Documentation
          </button>
          <span className="text-gray-400 dark:text-gray-600 transition-colors duration-300">|</span>
          <button
            onClick={() => onNavigate && onNavigate('contact-us')}
            className="text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-white transition-colors duration-200"
          >
            Contact Us
          </button>
        </div>
        <div className="flex items-center space-x-4 opacity-60 dark:opacity-80">
          <span className="text-gray-600 dark:text-gray-300 text-xs transition-colors duration-300">Trusted by leading financial institutions</span>
          <div className="flex items-center space-x-3">
            <i className="fa-brands fa-cc-visa text-lg text-blue-600 dark:text-blue-400 transition-colors duration-300"></i>
            <i className="fa-brands fa-cc-mastercard text-lg text-red-500 dark:text-red-400 transition-colors duration-300"></i>
            <i className="fa-solid fa-university text-lg text-gray-600 dark:text-gray-400 transition-colors duration-300"></i>
            <i className="fa-solid fa-shield-halved text-lg text-green-600 dark:text-green-400 transition-colors duration-300"></i>
            <div className="flex items-center text-xs text-gray-600 dark:text-gray-300 transition-colors duration-300">
              <i className="fa-solid fa-lock mr-1"></i>
              <span>Bank-grade Security</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default TrustSection; 